import { Outlet } from "react-router-dom";
import {
  LayoutDashboard,
  LifeBuoy,
  Ratio,
  Settings,
  SquareKanban,
  Wallet,
} from "lucide-react";
import Sidebar, { SidebarItem, SidebarSubItem } from "../sidebar/SidebarTwo";
import AppNavbar from "../navigation/AppNavbar";
import { useState } from "react";
import { useSelector } from "react-redux";
import { isAuth } from "../../util";

const Layout = () => {
  const [open, setOpen] = useState(false);
  const expanded = useSelector((state) => state.config.sidebarExpanded);
  const userPermissions = useSelector((state) => state.user.permissions);

  return (
    <div className="flex sm:h-dvh min-h-dvh bg-content overflow-auto mx-auto">
      <div
        className={`h-dvh hidden sm:block whitespace-nowrap  ${
          expanded ? "overflow-auto" : ""
        } `}
      >
        <Sidebar setOpen={setOpen}>
          <SidebarItem
            type="link"
            to="/dashboard"
            icon={<LayoutDashboard size={20} />}
            text="Dashboard"
          />

          {/* Manage Projects */}
          {isAuth(userPermissions, "projects", "read") && (
            <SidebarItem
              type="container"
              to="/reports"
              icon={<SquareKanban size={20} />}
              text="Council"
              children={[
                isAuth(userPermissions, "community_council", "read") && (
                  <SidebarSubItem
                    key={0}
                    text="Community Council"
                    to="/requests/community-approvals"
                  />
                ),
                isAuth(userPermissions, "community_council", "read") && (
                  <SidebarSubItem
                    key={1}
                    text="Community Reports"
                    to="/projects/community/reports"
                  />
                ),
                isAuth(userPermissions, "pdo_department", "read") && (
                  <SidebarSubItem
                    key={2}
                    text="PDO Dept"
                    to="/requests/pdo-approvals"
                  />
                ),
                isAuth(userPermissions, "pdo_department", "read") && (
                  <SidebarSubItem
                    key={3}
                    text="PDO Reports"
                    to="/projects/pdo/reports"
                  />
                ),
                isAuth(userPermissions, "provincial_council", "read") && (
                  <SidebarSubItem
                    key={4}
                    text="Provincial Council"
                    to="/requests/provincial-approvals"
                  />
                ),
                isAuth(userPermissions, "provincial_council", "read") && (
                  <SidebarSubItem
                    key={5}
                    text="Provincial Reports"
                    to="/projects/provincial/reports"
                  />
                ),
                isAuth(userPermissions, "accounts", "read") && (
                  <SidebarSubItem
                    key={6}
                    text="Accounts"
                    to="/projects/accounts"
                  />
                ),
                isAuth(userPermissions, "economer", "read") && (
                  <SidebarSubItem
                    key={7}
                    text="Economer "
                    to="/requests/economer-approvals"
                  />
                ),
                isAuth(userPermissions, "manage_projects", "read") && (
                  <SidebarSubItem key={8} text="Manage" to="/projects/manage" />
                ),
              ]}
            />
          )}

          {/* Projects */}
          <SidebarItem
            type="container"
            to="/projects"
            icon={<Ratio size={20} />}
            alert
            text="Projects"
            children={[
              isAuth(userPermissions, "projects", "read") && (
                <SidebarSubItem
                  key={0}
                  text="My Initatives"
                  to="/requests/my-requests"
                />
              ),
              isAuth(userPermissions, "pdo_department", "read") && (
                <SidebarSubItem
                  key={1}
                  text="Proposals"
                  to="/projects/proposals"
                />
              ),
              isAuth(userPermissions, "reformulation", "read") && (
                <SidebarSubItem
                  key={2}
                  text="Mails"
                  to="/projects/reformulations"
                />
              ),
              isAuth(userPermissions, "implementation", "read") && (
                <SidebarSubItem
                  key={3}
                  text="Implementation"
                  to="/projects/implementations"
                />
              ),
              isAuth(userPermissions, "evaluation", "read") && (
                <SidebarSubItem
                  key={4}
                  text="Evaluation"
                  to="/projects/evaluations"
                />
              ),

              isAuth(userPermissions, "projects", "read") && (
                <SidebarSubItem
                  key={5}
                  text="Canceled"
                  to="/projects/canceled-projects"
                />
              ),
              isAuth(userPermissions, "project_reports", "read") && (
                <SidebarSubItem
                  key={6}
                  text="Project Reports"
                  to="/project-reports"
                />
              ),
            ]}
          />

          {isAuth(userPermissions, "accounts", "read") && (
            <SidebarItem
              type="container"
              to="/accounts"
              icon={<Wallet size={20} />}
              text="Fund MGR"
              children={[
                isAuth(userPermissions, "accounts", "read") && (
                  <SidebarSubItem
                    key={1}
                    text="Settings"
                    to="/accounts/maintenance"
                  />
                ),
                isAuth(userPermissions, "accounts", "read") && (
                  <SidebarSubItem
                    key={1}
                    text="Transactions"
                    to="/accounts/transaction"
                  />
                ),
                isAuth(userPermissions, "accounts", "read") && (
                  <SidebarSubItem key={1} text="Report" to="/accounts/report" />
                ),
              ]}
            />
          )}
          {/* Settings */}
          <SidebarItem
            type="container"
            to="/settings"
            icon={<Settings size={20} />}
            text="Settings"
            children={[
              isAuth(userPermissions, "countries", "read") && (
                <SidebarSubItem
                  key={1}
                  text="Countries"
                  to="/settings/nations"
                />
              ),

              isAuth(userPermissions, "communities", "read") && (
                <SidebarSubItem key={2} text="Communities" to="/communities" />
              ),
              isAuth(userPermissions, "users", "read") && (
                <SidebarSubItem key={3} text="Users" to="/users" />
              ),
              isAuth(userPermissions, "roles", "read") && (
                <SidebarSubItem key={4} text="Roles" to="/settings/roles" />
              ),
              isAuth(userPermissions, "donors", "read") && (
                <SidebarSubItem key={5} text="Donors" to="/settings/donors" />
              ),
              isAuth(userPermissions, "chart", "read") && (
                <SidebarSubItem key={6} text="Chart" to="/settings/chart" />
              ),
              isAuth(userPermissions, "countries", "read") && (
                <SidebarSubItem key={7} text="Nation" to="/settings/nations" />
              ),
              isAuth(userPermissions, "settings", "read") && (
                <SidebarSubItem key={6} text="Settings" to="/settings" />
              ),
            ]}
          />

          <SidebarItem
            type="link"
            to="/help"
            icon={<LifeBuoy size={20} />}
            text="Help"
          />
        </Sidebar>
      </div>
      <main className="bg-bkg h-auto flex-1 flex flex-col overflow-x-auto">
        <AppNavbar open={open} setOpen={setOpen} />
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
